module.exports = __webpack_public_path__ + "portal-static/img/user_teacher.ec10bdd5.png";